import {Injectable, inject} from '@angular/core';
import {HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse, HttpEvent} from '@angular/common/http';
import {Observable, from, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {catchError, switchMap} from 'rxjs/operators';
import {environment} from '@environment/environment';
import {LogoutService} from '@services/api/logout/logout.service';
import {TokenStorageService} from '@services/local-storage/token-storage/token-storage.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private router: Router = inject(Router);
  private logout_service = inject(LogoutService);
  private token_storage_service = inject(TokenStorageService);
  private otpVerificationEndpoint = `${environment.api.base_url}/auth/verify-otp`;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.token_storage_service.getTokenStorage()).pipe(
      switchMap((token: string | null) => {
        // Per FormData il browser deve impostare Content-Type con il boundary automaticamente
        const isFormData = request.body instanceof FormData;
        let headers = isFormData
          ? request.headers.set('Accept', 'application/json')
          : request.headers.set('Content-Type', 'application/json').set('Accept', 'application/json');
        if (token) {
          headers = headers.set('Authorization', `Token ${token}`);
        }
        const clonedRequest = request.clone({headers});
        return next.handle(clonedRequest).pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.url !== this.otpVerificationEndpoint) {
              if (err.status === 401 || err.status === 403) {
                this.logout_service.logout();
              }
            }
            return throwError(() => err);
          })
        );
      })
    );
  }
}
